import z from "zod";

export enum EFFORT {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
  XHIGH = "xhigh",
  MAX = "max"
}

export const EffortLabelMap: Record<EFFORT, string> = {
  [EFFORT.LOW]: "Low",
  [EFFORT.MEDIUM]: "Medium",
  [EFFORT.HIGH]: "High",
  [EFFORT.XHIGH]: "Very High",
  [EFFORT.MAX]: "Maximum"
};

export enum CACHE_TTL {
  FIVE_MINUTES = "5m",
  ONE_HOUR = "1h"
}

export const CacheTtlLabelMap: Record<CACHE_TTL, string> = {
  [CACHE_TTL.FIVE_MINUTES]: "5 minutes",
  [CACHE_TTL.ONE_HOUR]: "1 hour"
};

export enum THINKING {
  DEFAULT = "default",
  ENABLED = "enabled",
  DISABLED = "disabled"
}

export const ThinkingLabelMap: Record<THINKING, string> = {
  [THINKING.DEFAULT]: "Provider default",
  [THINKING.ENABLED]: "Enabled",
  [THINKING.DISABLED]: "Disabled"
};

/** Lowest thinking budget the Anthropic API accepts. */
export const MIN_THINKING_BUDGET = 1024;

/**
 * A named wrapper around an Anthropic model. The same external model can be
 * configured several times (e.g. "Sonnet 5 low" vs "Sonnet 5 high") and skills
 * pick the variant they need.
 */
export const Model = z.object({
  label: z.string().optional(),
  price: z.string(),
  directToolUseOnly: z.boolean().optional(),
  externalModelId: z.string(),
  effort: z.enum(EFFORT).nullable().optional(),
  thinking: z.boolean().nullable().optional(),
  maxThinkingBudget: z.number().nullable().optional(),
  maxOutputTokens: z.number(),
  cacheTtl: z.enum(CACHE_TTL).nullable().optional(),
});

export type Model = z.infer<typeof Model>;

export const toThinkingMode = (thinking: Model["thinking"]): THINKING => {
  switch (thinking) {
    case true: return THINKING.ENABLED;
    case false: return THINKING.DISABLED;
    default: return THINKING.DEFAULT;
  }
};

export const fromThinkingMode = (mode: THINKING): boolean | null => {
  switch (mode) {
    case THINKING.ENABLED: return true;
    case THINKING.DISABLED: return false;
    default: return null;
  }
};
